<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .topic -->
    <b-form-group
      id="input-group-1"
      :label="$t('meetings.topic')"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="newItem.topic"
        type="text"
        :placeholder="$t('meetings.topic')"
      />
    </b-form-group>
    <!-- .start_time -->
    <b-form-group
      id="input-group-2"
      :label="$t('meetings.start_time')"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="newItem.start_time"
        type="text"
        :placeholder="$t('meetings.start_time')"
      />
    </b-form-group>
    <!-- .password -->
    <b-form-group
      id="input-group-3"
      :label="$t('meetings.password')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.password"
        type="text"
        :placeholder="$t('meetings.password')"
      />
    </b-form-group>
    <!-- .start_url -->
    <b-form-group
      id="input-group-4"
      :label="$t('meetings.start_url')"
      label-for="input-4"
    >
      <b-form-input
        id="input-4"
        v-model="newItem.start_url"
        type="text"
        :placeholder="$t('meetings.start_url')"
      />
    </b-form-group>
    <!-- .join_url -->
    <b-form-group
      id="input-group-5"
      :label="$t('meetings.join_url')"
      label-for="input-5"
    >
      <b-form-input
        id="input-5"
        v-model="newItem.join_url"
        type="text"
        :placeholder="$t('meetings.join_url')"
      />
    </b-form-group>
    <!-- .duration -->
    <b-form-group
      id="input-group-6"
      :label="$t('meetings.duration')"
      label-for="input-6"
    >
      <b-form-input
        id="input-6"
        v-model="newItem.duration"
        type="text"
        :placeholder="$t('meetings.duration')"
      />
    </b-form-group>
    <!-- .meeting -->
    <b-form-group
      id="input-group-7"
      :label="$t('meetings.meeting')"
      label-for="input-7"
    >
      <Select2
        id="input-7"
        v-model="newItem.meeting"
        :options="meetingOptions"
      />
    </b-form-group>        <!-- .meeting_uuid -->
    <b-form-group
      id="input-group-8"
      :label="$t('meetings.meeting_uuid')"
      label-for="input-8"
    >
      <b-form-input
        id="input-8"
        v-model="newItem.meeting_uuid"
        type="text"
        :placeholder="$t('meetings.meeting_uuid')"
      />
    </b-form-group>

    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Select2 from 'v-select2-component'
import Controller from '../../../../Controllers/MeetingsController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'MeetingsForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      
      meeting: [],

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
